import React from 'react';
import FrameImage from '../assets/images/sabhaSaarFrame.png';
import Wrapper from '../assets/wrappers/WelcomeBox';

const WelcomeBox: React.FC = () => {
    return (
        <Wrapper>
            <div className=" p-3">
                {/* <div className="box-bg-yellow"></div> */}
                <h3 className="boxHeading">Welcome to SabhaSaar</h3>
                <p className="boxPara">
                    Transforming the way local governance is documented, this intelligent tool
                    leverages AI to automatically generate structured Minutes of Meeting (MoM)
                    from Gram Sabha videos and audio recordings. Ideal for panchayats, administrative
                    bodies, and rural development projects, it streamlines documentation and empowers
                    stakeholders with instant access to meeting insights.
                </p>
                <div className="text-center">
                    <img src={FrameImage} className='sabhaSaarFrame' alt="sabhaSaarFrame" />
                </div>
            </div>
        </Wrapper>
    );
};

export default WelcomeBox;
